import { twMerge } from "tailwind-merge";
import { Check } from "lucide-react";
import { CheckCircleBase, type CheckCircleBaseProps } from "@core/ui";

export type Props = Omit<CheckCircleBaseProps, "renderIcon">;

/**
 * Styled check circle component wrapping CheckCircleBase.
 * Displays a circular check indicator for success states.
 */
export function CheckCircle({ isDisabled = false, className, ...props }: Props) {
  return (
    <CheckCircleBase
      isDisabled={isDisabled}
      className={twMerge(
        "ml-2 rounded-full p-2",
        isDisabled ? "border-brand-300" : "bg-brand-600",
        className
      )}
      data-testid="check-circle"
      renderIcon={({ isDisabled: disabled }) => (
        <Check
          className={twMerge(
            "w-4 h-4",
            disabled ? "text-brand-400" : "text-brand-50"
          )}
          strokeWidth={3}
        />
      )}
      {...props}
    />
  );
}

export default CheckCircle;

